import { Route } from '@angular/router';

export const InstitutionsRoute: Route = {
  path: 'institutions',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/institutions_shell'
    ).then((c) => c.institutionsShellRoutes);
  },
};
